export default {
  setProductId(context, payload) {
    context.commit("setProductId", payload);
  },
  setAddress(context, payload) {
    context.commit("setAddress", payload);
  },
  setPersonalInformation(context, payload) {
    context.commit("setPersonalInformation", payload);
  },
  setBankAccount(context, payload) {
    context.commit("setBankAccount", payload);
  },
  setFundSelection(context, payload) {
    context.commit("setFundSelection", payload);
  },
  setFundAllocation(context, payload) {
    context.commit("setFundAllocation", payload);
  },
};
